/**
 * The status badge for a support ticket (Administration → Tickets).
 */

import { Badge } from "@mantine/core";
import type { TicketStatus } from "@/shared/api/tickets";
import { STATUS_LABEL } from "./ticketFormat";

const STATUS_COLOR: Record<TicketStatus, string> = {
  open: "blue",
  in_progress: "yellow",
  resolved: "green",
  closed: "gray",
};

export function TicketStatusBadge({ status }: { status: TicketStatus }) {
  return (
    <Badge color={STATUS_COLOR[status]} variant="light" data-testid="ticket-status">
      {STATUS_LABEL[status]}
    </Badge>
  );
}
